app.controller(
    'AdminMainController', ['$scope', AdminMainController]
);

function AdminMainController($scope) {

    $scope.formatGens = [
        {
            id: 1,
            openDropdown: false
        }
    ];

    /**
     * add format general
     */
    $scope.addGenFormat = function () {
        var id = $scope.formatGens.length + 1;
        $scope.formatGens.push({
            id : id,
            openDropdown : true
        })
    };

    /**
     * Remove format (Format general)
     * @param format
     */
    $scope.removeGenFormat = function (format) {
        $scope.formatGens.splice(format, 1);
    };
};